'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.PrelaunchSection = exports.STATIC_TIMEZONE = exports.OFFSET_TO_MS = exports.TIME_ATTR = exports.COUNTER_ROW = exports.CONTAINER_SELECTOR = undefined;

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

var _ShopifySection2 = require('./../ShopifySection');

var _pcSlateTools = require('@process-creative/pc-slate-tools');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CONTAINER_SELECTOR = exports.CONTAINER_SELECTOR = '[data-template-prelaunch]'; /*
                                                                                    *  Prelaunch
                                                                                    *    Scripts for the Prelaunch landing pages.
                                                                                    *
                                                                                    *
                                                                                    *  Version:
                                                                                    *    1.0.0 - 2019/05/13
                                                                                    */

var COUNTER_ROW = exports.COUNTER_ROW = '[data-counter-row]';

var TIME_ATTR = exports.TIME_ATTR = 'data-countdown-end';
var OFFSET_TO_MS = exports.OFFSET_TO_MS = 60000;
var STATIC_TIMEZONE = exports.STATIC_TIMEZONE = -600; //Offset that the end date will be set in.

var PrelaunchSection = exports.PrelaunchSection = function (_ShopifySection) {
    (0, _inherits3.default)(PrelaunchSection, _ShopifySection);

    function PrelaunchSection(container) {
        (0, _classCallCheck3.default)(this, PrelaunchSection);

        var _this = (0, _possibleConstructorReturn3.default)(this, (PrelaunchSection.__proto__ || Object.getPrototypeOf(PrelaunchSection)).call(this, container));

        _this.container = container;

        _this.counterRow = container.find(COUNTER_ROW);

        if (_this.counterRow.length) {
            _this.end = (0, _pcSlateTools.liquidToDate)('' + _this.container.attr(TIME_ATTR));
            _this.targetTimezone = STATIC_TIMEZONE * OFFSET_TO_MS;

            //Start Timer
            setInterval(function () {
                return _this.tick();
            }, 200);
        }
        return _this;
    }

    (0, _createClass3.default)(PrelaunchSection, [{
        key: 'tick',
        value: function tick() {

            var now = new Date(); //System Time
            var myTimezone = now.getTimezoneOffset() * OFFSET_TO_MS;
            var diff = now.getTime() + myTimezone - (this.end.getTime() + this.targetTimezone);
            if (diff >= 0) return; // Time remaining should be negative, return if not
            diff = Math.abs(diff); // We've got time remaining, but we need abs value

            var days = Math.floor(diff / (1000 * 60 * 60 * 24));
            var hours = Math.floor(diff % (1000 * 60 * 60 * 24) / (1000 * 60 * 60));
            var minutes = Math.floor(diff % (1000 * 60 * 60) / (1000 * 60));
            var seconds = Math.floor(diff % (1000 * 60) / 1000);

            var p = function p(n) {
                return ('' + n).padStart(2, '0');
            };

            var print = '<td>' + p(days) + '</td><td class="separator">:</td><td>' + p(hours) + '</td><td class="separator">:</td><td>' + p(minutes) + '</td><td class="separator">:</td><td>' + p(seconds) + '</td>';
            this.counterRow.html(print);
        }
    }]);
    return PrelaunchSection;
}(_ShopifySection2.ShopifySection);

(0, _ShopifySection2.register)(CONTAINER_SELECTOR, PrelaunchSection);